module.exports = __webpack_public_path__ + "img/file.bb6307f6.png";